import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { usePartnerAccount } from '../../providers/PartnerAccount.provider';
import { useConfirmationDialogue } from '../../providers/ConfirmationDialogue.provider';
import { PartnerAccountRequest, PartnerAccountResponse } from '../useApi/usePostPartnerAccount';
import { usePendingData } from '../../providers/PendingData.provider';

const useAccountCreationFailureDialogue = (): {
  showDialogue: () => void;
  response: PartnerAccountResponse | undefined;
  postPartnerAccount: (requestParams: PartnerAccountRequest) => void;
} => {
  const history = useHistory();
  const { t } = useTranslation('translations', { keyPrefix: 'Hooks.UseAccountCreationFailureDialogue' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });

  const { response, postPartnerAccount } = usePartnerAccount();
  const { reset } = usePendingData();
  const { provideProps, showDialogue } = useConfirmationDialogue();

  useEffect(() => {
    const handlers = {
      error: () => {
        provideProps({
          title: t('errorTitle', { defaultValue: 'Error! Your account has not been created.' }),
          subTitle: response?.errorMessage || '',
          status: 'error',
          confirm: {
            label: tGlobal('Buttons.backToAccounts'),
            action: () => {
              reset();
              history.push('/accounts');
            },
          },
          cancel: {
            label: tGlobal('Buttons.stayHere'),
            action: () => {},
          },
        });
      },
    };

    if (response?.errorMessage) handlers.error();
  }, [response]);

  return { showDialogue, response, postPartnerAccount };
};

export default useAccountCreationFailureDialogue;
